import BusinessTab from './BusinessTab.tsx';

export { BusinessTabTitle } from './BusinessTab.tsx';

export default BusinessTab;
